import React from 'react';
import InputMask from 'react-input-mask';

class ContactForm extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            name: '',
            firstName: '',
            lastName: '',
            contact_email: '',
            contact_number: '',
            message: '',
            contactFormStatus: this.props.contactFormStatus === false ? this.props.contactFormStatus : true,
            contactEmailStatus: this.props.contactEmailStatus ? this.props.contactFormStatus : false,
            contactNumberStatus: this.props.contactNumberStatus ? this.props.contactNumberStatus : false
        };
    }

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.validateForm()) {
            let parent = this;
            fetch(process.env.REACT_APP_BASE_URL + 'web/' + this.props.PCBID + '/query', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(this.state)
            }).then(function (response) {
                parent.setState({
                    firstName: '',
                    lastName: '',
                    contact_email: '',
                    contact_number: '',
                    message: ''
                });
                parent.props.onClick();
            });
        }
    }

    removeRequiredClass = (type) => {
        let errors = this.state.contactFormErrors ? this.state.contactFormErrors : {};
        switch (type) {
            case 'firstName':
                errors.firstNameClass = '';
                break;
            case 'email':
                errors.emailClass = '';
                break;
            case 'phone':
                errors.phoneClass = '';
                break;
            case 'message':
                errors.messageClass = '';
                break;
        }
        this.setState(
            {
                contactFormErrors: errors
            }, () => {
                return false
            });
    }

    validateForm = () => {
        let errors = {}
        if (typeof (this.state.firstName) === 'undefined' || this.state.firstName === null || this.state.firstName === '') {
            errors.firstNameClass = 'required';
        }
        if (typeof (this.state.message) === 'undefined' || this.state.message === null || this.state.message === '') {
            errors.messageClass = 'required';
        }
        if (this.state.contactEmailStatus) {
            if (typeof (this.state.contact_email) === 'undefined' || this.state.contact_email === null || this.state.contact_email === '') {
                errors.emailClass = 'required';
            }
        }
        if (this.state.contactNumberStatus) {
            if (typeof (this.state.contact_number) === 'undefined' || this.state.contact_number === null || this.state.contact_number === '') {
                errors.phoneClass = 'required';
            }
        }
        if (Object.keys(errors).length === 0 && errors.constructor === Object) {
            return true;
        } else {
            let here = this;
            this.setState(
                {
                    contactFormErrors: errors
                }, () => {
                    here.gotoElement('goto-contact-header')
                    return false
                });
        }
    }

    gotoElement(elemID) {
        let elem = document.getElementById(elemID);
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = elem.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - 130;

        let left = elem.getBoundingClientRect().left - 20;
        window.scrollTo({
            top: offsetPosition,
            left: left,
            behavior: 'smooth'
        });
    }

    handleChange = (event, capitalize = false) => {
        let fieldName = event.target.name;
        let result = capitalize ? this.capitalizeFirstCharacter(event.target.value) : event.target.value;
        this.setState({
            [event.target.name]: result
        }, function (e) {
            if (fieldName === 'firstName' || fieldName === 'lastName') {
                let fullName;
                if (this.state.lastName && this.state.lastName !== '') {
                    fullName = this.state.firstName + ' ' + this.state.lastName;
                } else {
                    fullName = this.state.firstName;
                }
                this.setState({
                    name: fullName,
                })
            }
        });
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            contactFormStatus: nextProps.contactFormStatus,
            contactEmailStatus: nextProps.contactEmailStatus,
            contactNumberStatus: nextProps.contactNumberStatus
        });
    }

    capitalizeFirstCharacter(value) {
        return value.charAt(0).toUpperCase() + value.slice(1)
    }

    showContactEmail = () => {
        if (this.state.contactEmailStatus)
            return (
                <>
                    {/* <label>Email</label> */}
                    <input type="email" id={this.state.contactFormErrors && this.state.contactFormErrors.emailClass}
                           placeholder="Email" name='contact_email' onChange={this.handleChange}
                           value={this.state.contact_email} onFocus={i => this.removeRequiredClass('email')}
                    />
                </>
            )
    }

    showContactNumber = () => {
        if (this.state.contactNumberStatus)
            return (
                <>
                    {/* <label>Phone</label> */}
                    <InputMask mask="(999) 999-9999"
                               id={this.state.contactFormErrors && this.state.contactFormErrors.phoneClass}
                               placeholder="Phone" name='contact_number' onChange={this.handleChange}
                               value={this.state.contact_number} onFocus={i => this.removeRequiredClass('phone')}
                    />
                </>
            )
    }

    showContactUsForm = () => {
        if (this.state.contactFormStatus) {
            return (
                <form className="contact-form" onSubmit={this.handleSubmit}>
                    <div className='form-row'>
                        <div className='col'>
                            <input type="text"
                                   id={this.state.contactFormErrors && this.state.contactFormErrors.firstNameClass}
                                   className='name-field'
                                   placeholder="First Name" name='firstName' onChange={this.handleChange}
                                   value={this.state.firstName} onFocus={i => this.removeRequiredClass('firstName')}
                            />
                        </div>
                        <div className='col'>
                            <input type="text"
                                   className='name-field'
                                   placeholder="Last Name" name='lastName' onChange={this.handleChange}
                                   value={this.state.lastName}
                            />
                        </div>
                    </div>
                    <div className='form-row'>
                        <div className='col'>{this.showContactEmail()}</div>
                        <div className='col'>{this.showContactNumber()}</div>
                    </div>
                    {/* <label>Message</label> */}
                    <div className='form-row'>
                        <textarea placeholder="How can we help you?"
                                  id={this.state.contactFormErrors && this.state.contactFormErrors.messageClass}
                                  name='message' onChange={i => this.handleChange(i, true)} value={this.state.message}
                                  onFocus={i => this.removeRequiredClass('message')}>
                        </textarea>
                    </div>
                    <div className='form-row'>
                        <button className="btn btn__borderd" type="submit">
                            Submit
                        </button>
                    </div>
                </form>
            )
        } else {
            return ''
        }
    }

    render() {
        return (
            this.showContactUsForm()
        )
    };

}

export default ContactForm;
    